// constants

import { ComplaintsActionTypes } from "./constants";

export interface ComplaintsActionType {
  type:
    | ComplaintsActionTypes.API_RESPONSE_SUCCESS
    | ComplaintsActionTypes.API_RESPONSE_ERROR
    | ComplaintsActionTypes.GET_COMPLAINTS
    | ComplaintsActionTypes.CHANGE_STATUS;

  payload: {} | string;
}

interface ChangeComplaintStatusPayload {
  complaintId: string;
  status: string;
}

// common success
export const ComplaintsApiResponseSuccess = (actionType: string, data: any | {}): ComplaintsActionType => ({
  type: ComplaintsActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// common error
export const ComplaintsApiResponseError = (actionType: string, error: string): ComplaintsActionType => ({
  type: ComplaintsActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// get complaints action
export const getComplaints = (issueType?: string, status?: string, page?: number, limit?: number): ComplaintsActionType => ({
  type: ComplaintsActionTypes.GET_COMPLAINTS,
  payload: { issueType, status, page, limit },
});

// change complaint status action
export const changeComplaintStatus = ({ complaintId, status }: ChangeComplaintStatusPayload): ComplaintsActionType => ({
  type: ComplaintsActionTypes.CHANGE_STATUS,
  payload: { complaintId, status },
});
